var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "width": "95%",
      "height": "auto",
      "is-loc": "center"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "energy__img"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/tickets.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "energy__subtitle"
  }, [_vm._v(" By participating in the app center, you can get more tickets, and the more tickets you have, the more rewards you will get, including airdrops. ")]), _c('div', {
    staticClass: "btn-level",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("I see")) + " ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };